/* ============================================================
   Stane B2B Offerte Page — JavaScript
   Modules: Calculator, Smooth Scroll, Sticky Mobile CTA, Form
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  initCalculator();
  initSmoothScroll();
  initStickyMobileCTA();
  initFormHandling();
});

/* -----------------------------------------------------------
   1. CALCULATOR
   ----------------------------------------------------------- */
function initCalculator() {
  var section = document.querySelector('[data-stane-calculator]');
  if (!section) return;

  var slider = section.querySelector('[data-calc-slider]');
  var numberInput = section.querySelector('[data-calc-number]');
  var radios = section.querySelectorAll('[data-calc-radio]');
  var totalEl = section.querySelector('[data-calc-total]');
  var perEl = section.querySelector('[data-calc-per]');
  var discountBadge = section.querySelector('[data-calc-discount]');
  var discountText = section.querySelector('[data-calc-discount-text]');
  var savingsEl = section.querySelector('[data-calc-savings]');
  var savingsAmountEl = section.querySelector('[data-calc-savings-amount]');

  if (!slider || !numberInput || !totalEl || !perEl) return;

  // Read prices from global object (set by Liquid) or use defaults
  var prices = window.staneB2BPrices || {
    bureaustoel: 229,
    bureau: 239,
    'stoel-bureau': 470,
    compleet: 500
  };

  var state = {
    quantity: parseInt(slider.value) || 15,
    type: 'bureaustoel'
  };

  function getDiscountPercent(qty) {
    if (qty < 15) return 0;
    var stappen = Math.floor(qty / 15);
    return Math.min(stappen * 2.5, 25);
  }

  function formatPrice(amount) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  function calculate() {
    var basePrice = prices[state.type] * state.quantity;
    var pct = getDiscountPercent(state.quantity);
    var discount = pct / 100;
    var total = Math.round(basePrice * (1 - discount));
    var perWorkplace = Math.round(total / state.quantity);

    totalEl.textContent = formatPrice(total);
    perEl.innerHTML = 'Dat is <strong>' + formatPrice(perWorkplace) + '</strong> per werkplek';

    // Staffelkorting badge — alleen tonen bij 15+
    if (discountBadge && discountText) {
      if (pct > 0) {
        discountText.textContent = 'Inclusief ' + pct + '% staffelkorting';
        discountBadge.style.display = '';
      } else {
        discountBadge.style.display = 'none';
      }
    }

    // Besparing — alleen tonen bij korting
    if (savingsEl && savingsAmountEl) {
      var savings = Math.round(basePrice - total);
      if (savings > 0) {
        savingsAmountEl.textContent = formatPrice(savings);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  // Sync slider ↔ number input
  slider.addEventListener('input', function () {
    var val = parseInt(this.value);
    if (val >= 1 && val <= 200) {
      state.quantity = val;
      numberInput.value = val;
      calculate();
    }
  });

  numberInput.addEventListener('input', function () {
    var val = parseInt(this.value);
    if (val >= 1 && val <= 200) {
      state.quantity = val;
      slider.value = val;
      calculate();
    }
  });

  numberInput.addEventListener('blur', function () {
    var val = parseInt(this.value);
    if (isNaN(val) || val < 1) {
      this.value = 1;
      state.quantity = 1;
      slider.value = 1;
    } else if (val > 200) {
      this.value = 200;
      state.quantity = 200;
      slider.value = 200;
    }
    calculate();
  });

  // Radio buttons (segmented control)
  var radioLabels = section.querySelectorAll('[data-calc-radio-label]');
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      state.type = this.value;
      // Update active state on labels
      radioLabels.forEach(function (label) {
        label.classList.remove('stane-b2b-calculator__radio-label--active');
      });
      this.closest('[data-calc-radio-label]').classList.add('stane-b2b-calculator__radio-label--active');
      calculate();
    });
  });

  // Initial calculation
  calculate();
}

/* -----------------------------------------------------------
   2. SMOOTH SCROLL
   ----------------------------------------------------------- */
function initSmoothScroll() {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var links = document.querySelectorAll('a[href="#offerte-formulier"]');
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('offerte-formulier');
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({
          top: top,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      }
    });
  });
}

/* -----------------------------------------------------------
   3. STICKY MOBILE CTA
   ----------------------------------------------------------- */
function initStickyMobileCTA() {
  var mobileCTA = document.querySelector('[data-stane-mobile-cta]');
  var hero = document.querySelector('[data-stane-hero]');
  var form = document.getElementById('offerte-formulier');

  if (!mobileCTA || !hero) return;

  var heroVisible = true;
  var formVisible = false;

  function updateVisibility() {
    if (!heroVisible && !formVisible) {
      mobileCTA.classList.add('stane-b2b-mobile-cta--visible');
    } else {
      mobileCTA.classList.remove('stane-b2b-mobile-cta--visible');
    }
  }

  var heroObserver = new IntersectionObserver(function (entries) {
    heroVisible = entries[0].isIntersecting;
    updateVisibility();
  }, { threshold: 0 });

  heroObserver.observe(hero);

  if (form) {
    var formObserver = new IntersectionObserver(function (entries) {
      formVisible = entries[0].isIntersecting;
      updateVisibility();
    }, { threshold: 0.1 });
    formObserver.observe(form);
  }
}

/* -----------------------------------------------------------
   4. FORM HANDLING
   ----------------------------------------------------------- */
function initFormHandling() {
  var form = document.querySelector('[data-stane-b2b-form]');
  if (!form) return;

  // Disable native browser validation — we handle it ourselves
  form.setAttribute('novalidate', '');

  // Checkbox styling — toggle .is-checked on label
  var checkboxes = form.querySelectorAll('[data-need-checkbox]');
  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', function () {
      var label = this.closest('.stane-b2b-formulier__checkbox-label');
      if (label) {
        if (this.checked) {
          label.classList.add('is-checked');
        } else {
          label.classList.remove('is-checked');
        }
      }
    });
  });

  // Client-side validation + checkbox collection on submit
  form.addEventListener('submit', function (e) {
    // Collect checkbox values into hidden field
    var checkedBoxes = form.querySelectorAll('[data-need-checkbox]:checked');
    var values = [];
    checkedBoxes.forEach(function (cb) {
      values.push(cb.value);
    });
    var hiddenField = form.querySelector('[data-needs-hidden]');
    if (hiddenField) {
      hiddenField.value = values.join(', ');
    }

    // Clear previous errors
    var allErrors = form.querySelectorAll('.stane-b2b-formulier__error');
    allErrors.forEach(function (el) {
      el.classList.remove('is-visible');
    });
    var allInvalid = form.querySelectorAll('.is-invalid');
    allInvalid.forEach(function (el) {
      el.classList.remove('is-invalid');
    });

    // Validate required fields
    var hasError = false;
    var firstError = null;

    var requiredFields = [
      { input: form.querySelector('[name="contact[company]"]'), error: form.querySelector('[data-error-for="company"]') },
      { input: form.querySelector('[name="contact[name]"]'), error: form.querySelector('[data-error-for="name"]') },
      { input: form.querySelector('[name="contact[email]"]'), error: form.querySelector('[data-error-for="email"]') }
    ];

    requiredFields.forEach(function (field) {
      if (!field.input || !field.error) return;
      var value = field.input.value.trim();
      var isValid = true;

      if (!value) {
        isValid = false;
      } else if (field.input.type === 'email') {
        // Basic email validation
        isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      if (!isValid) {
        field.input.classList.add('is-invalid');
        field.error.classList.add('is-visible');
        hasError = true;
        if (!firstError) {
          firstError = field.input;
        }
      }
    });

    if (hasError) {
      e.preventDefault();
      if (firstError) {
        var top = firstError.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
        firstError.focus();
      }
    }
  });

  // Clear error on input
  form.addEventListener('input', function (e) {
    var input = e.target;
    if (input.classList.contains('is-invalid')) {
      input.classList.remove('is-invalid');
      var errorSpan = input.parentElement.querySelector('.stane-b2b-formulier__error');
      if (errorSpan) {
        errorSpan.classList.remove('is-visible');
      }
    }
  });
}

/* -----------------------------------------------------------
   5. UTM TRACKING — fill hidden fields + parallel webhook
   -----------------------------------------------------------
   Runs as a separate IIFE so the existing form-logic above stays
   untouched. The new submit listener is registered AFTER the one in
   initFormHandling(), so it fires AFTER validation. We bail when
   e.defaultPrevented is true (= validation failed in the earlier
   listener), so a failing form never produces a webhook call or GA4
   event.
   ----------------------------------------------------------- */
(function () {
  'use strict';

  var APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxk5MhNIaiRKYvT_MBe3eJzy_Wt57Um5eyt2yMl9fNnRKjHkJg7bzZdM1_KWfu-sGgs/exec';
  // Secret is readable in client JS — acceptable as a bot-deterrent for the
  // webhook (per briefing). Real auth would require a server-side proxy.
  var SHARED_SECRET = 'ebrClYkKfkzmd5LtkSzoZqIdtqWMTrsU';

  function fillUtmFields(form) {
    var firstTouch = (typeof window.staneGetFirstTouch === 'function')
      ? window.staneGetFirstTouch()
      : null;
    if (!firstTouch) return;
    var inputs = form.querySelectorAll('[data-utm]');
    for (var i = 0; i < inputs.length; i++) {
      var key = inputs[i].getAttribute('data-utm');
      inputs[i].value = firstTouch[key] || '';
    }
  }

  function getDeviceType() {
    var ua = navigator.userAgent || '';
    if (/tablet|ipad/i.test(ua)) return 'tablet';
    if (/mobile|android|iphone/i.test(ua)) return 'mobile';
    return 'desktop';
  }

  function generateSubmissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    // RFC4122 v4 fallback (older browsers)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function buildPayload(form) {
    var fd = new FormData(form);
    function v(name) { return fd.get(name) || ''; }
    return {
      submission_id: generateSubmissionId(),
      secret: SHARED_SECRET,
      company: v('contact[company]'),
      name: v('contact[name]'),
      email: v('contact[email]'),
      phone: v('contact[phone]'),
      werkplekken: v('contact[aantal_werkplekken]'),
      benodigdheden: v('contact[benodigdheden]'),
      body: v('contact[body]'),
      utm_source: v('contact[utm_source]'),
      utm_medium: v('contact[utm_medium]'),
      utm_campaign: v('contact[utm_campaign]'),
      utm_term: v('contact[utm_term]'),
      utm_content: v('contact[utm_content]'),
      gclid: v('contact[gclid]'),
      fbclid: v('contact[fbclid]'),
      landing_page: v('contact[landing_page]'),
      referrer: v('contact[referrer]'),
      first_touch_date: v('contact[first_touch_date]'),
      submit_page: window.location.href,
      device: getDeviceType()
    };
  }

  // Web-safe base64 (RFC 4648 §5) — Apps Script's
  // Utilities.base64DecodeWebSafe() expects this variant (- instead of +,
  // _ instead of /, no padding).
  function base64UrlEncode(str) {
    var b64 = btoa(unescape(encodeURIComponent(str)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function isDebug() {
    return window.location.search.indexOf('stane_debug=1') !== -1;
  }

  // Multi-channel submission (image beacon + sendBeacon + fetch keepalive),
  // alle drie parallel afgevuurd met identieke submission_id. Server-side
  // dedupliceert via CacheService op submission_id (5 min TTL) — eerste
  // ontvangen wint, andere worden geskipt. Robuust tegen Chrome Tracking
  // Protection, third-party cookie blocking, sendBeacon queue limits,
  // service worker interference, en CSP-quirks.
  function sendToWebhook(payload) {
    var debug = isDebug();
    var body = JSON.stringify(payload);

    // Channel 1: Image beacon (GET met base64 in URL param). Door Chrome's
    // tracking-protection het minst geblokkeerd: GET requests worden
    // gedragen alsof ze een resource laden, niet als tracking-call.
    try {
      var encoded = base64UrlEncode(body);
      var beaconUrl = APPS_SCRIPT_URL + '?b=' + encoded;
      // Chrome heeft een effectieve URL-limit van ~32KB (RFC zegt 8KB
      // minimum). Onze volledige payload met UTMs ~ 1100 chars na encoding,
      // ruim binnen elke browser limit.
      var img = new Image();
      img.onload = function () { if (debug) console.log('[stane-utm] image beacon: load'); };
      img.onerror = function () { if (debug) console.log('[stane-utm] image beacon: error (verwacht — body is geen image)'); };
      img.src = beaconUrl;
    } catch (e) {
      if (debug) console.warn('[stane-utm] image beacon failed:', e);
    }

    // Channel 2: sendBeacon POST (was eerder primair, nu redundant pad voor
    // browsers die de URL-method blokkeren maar Beacon API toestaan).
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        var queued = navigator.sendBeacon(APPS_SCRIPT_URL, blob);
        if (debug) console.log('[stane-utm] sendBeacon queued:', queued);
      }
    } catch (e) {
      if (debug) console.warn('[stane-utm] sendBeacon failed:', e);
    }

    // Channel 3: fetch POST keepalive (voor browsers waar sendBeacon
    // refused queueing of de queue al vol zit bij page-unload).
    try {
      fetch(APPS_SCRIPT_URL, {
        method: 'POST', body: body, keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        mode: 'no-cors'
      }).then(function () {
        if (debug) console.log('[stane-utm] fetch keepalive completed');
      }).catch(function (err) {
        if (debug) console.warn('[stane-utm] fetch keepalive failed:', err);
      });
    } catch (e) {
      if (debug) console.warn('[stane-utm] fetch invocation failed:', e);
    }
  }

  // Client-side validation guard. Mirrors initFormHandling()'s required-field
  // checks so the UTM handler doesn't fire on invalid forms even when the
  // earlier handler's preventDefault() doesn't propagate (handler-order race
  // observed in production — empty-name/email submits still queued beacons).
  function isFormValid(form) {
    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value.trim() : '';
    }
    if (!val('contact[company]') || !val('contact[name]')) return false;
    var email = val('contact[email]');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false;
    return true;
  }

  function fireGA4Event(payload) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'b2b_lead_submit', {
          event_category: 'lead',
          event_label: payload.utm_campaign || '(direct)',
          utm_source: payload.utm_source || '(direct)',
          utm_medium: payload.utm_medium || '(none)',
          utm_campaign: payload.utm_campaign || '',
          aantal_werkplekken: payload.werkplekken || ''
        });
      }
    } catch (e) {
      // Tracking errors never block submit
    }
  }

  function init() {
    var form = document.querySelector('[data-stane-b2b-form]');
    if (!form) return;

    // Fill once at DOMContentLoaded so the values are present before any
    // submission. We also re-fill at submit time as a safety net (cookie
    // could have been written between load and submit).
    fillUtmFields(form);

    form.addEventListener('submit', function (e) {
      // Belt-and-suspenders skip:
      //   1. defaultPrevented (validation handler ran first AND propagated)
      //   2. our own client-side validity check (covers handler-order races
      //      where UTM listener happens to run before validation).
      if (e.defaultPrevented || !isFormValid(form)) {
        if (isDebug()) console.log('[stane-utm] webhook skipped: invalid form');
        return;
      }

      fillUtmFields(form);
      var payload = buildPayload(form);
      sendToWebhook(payload);
      fireGA4Event(payload);
      // Native submit continues — Shopify form POST → /contact → mail.
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

